module.exports = require('./datahandler.js');


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-datahandler/index.js
// module id = 809
// module chunks = 0